module.exports = __webpack_public_path__ + "6f9236bef168c1dbcb26253925b37518.png";